/**
 * Dataset helpers for routed actions
 */

function decodeHtmlEntities(s) {
  if (typeof s !== 'string') return s;
  return s.replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&');
}

export function parseDataJSON(value, fallback = null) {
  try {
    if (!value) return fallback;
    const decoded = decodeHtmlEntities(String(value));
    return JSON.parse(decoded);
  } catch (_) { return fallback; }
}

export function getDatasetContext(target) {
  const ds = target?.dataset || {};
  const id = ds.id ?? ds.itemId ?? null;
  const index = (ds.index !== undefined) ? Number(ds.index) : null;
  const json = parseDataJSON(ds.json, null);
  return { id, index, json, raw: { ...ds } };
}

export default { parseDataJSON, getDatasetContext };

